import chroma from 'chroma-js';

const mainPalette = ['#31a659', '#f56954', '#d2d6de', '#f39c12', '#41c0ef', '#3c8dbc'];

export const generateColors = (count: number, opacity = 1, palette = mainPalette): string[] => chroma
  .scale(palette)
  .colors(count)
  .map((color) => chroma(color).alpha(opacity).css());
